/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class AzureTenant {
  /**
  * The tenant ID
  */
  'id': string;
  /**
  * The tenant display name
  */
  'displayName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "displayName",
      "baseName": "displayName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureTenant.attributeTypeMap;
  }

  public constructor() {
  }
}

